export const arr     = subject => Array.isArray(subject);
export const bool    = subject => typeof subject === 'boolean';
export const obj     = subject => typeof subject === 'object' && !arr(subject) && !el(subject) && subject.constructor === Object;
export const str     = subject => typeof subject === 'string';
export const num     = subject => typeof subject === 'number' && !isNaN(subject);
export const fun     = subject => typeof subject === 'function' || (typeof subject === 'object' && subject.constructor !== Object);
export const def     = subject => typeof subject !== 'undefined';
export const el      = subject => subject instanceof HTMLElement;
export const jsonStr = subject => str(subject) && (new RegExp('{(.+)?}', 'g')).test(subject);


// WEBPACK FOOTER //
// ./src/Services/Misc/is.js